var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrivacyIcon = function SvgPrivacyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9FB3BC",
    d: "M11.904 2.839C9.06 4.678 5.267 5.597 2.422 5.597c0 6.436 2.845 12.872 9.482 15.63 6.638-2.758 9.482-9.194 9.482-15.63-2.844 0-6.637-.92-9.482-2.758z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8ED",
    d: "M22.335 4.218h-.949c-2.906 0-6.318-.992-8.693-2.527l-.526-.34a.486.486 0 0 0-.525 0l-.526.34C8.74 3.226 5.329 4.218 2.422 4.218h-.948a.467.467 0 0 0-.474.46v.92c0 7.888 3.867 14.205 10.344 16.896l.374.156a.485.485 0 0 0 .373 0l.374-.156c6.477-2.691 10.344-9.008 10.344-16.897v-.92a.467.467 0 0 0-.474-.46zm-10.43 16.507C6.38 18.34 3.041 12.89 2.9 6.049c3.076-.095 6.455-1.092 9.003-2.662 2.549 1.57 5.928 2.567 9.004 2.662-.141 6.84-3.48 12.292-9.004 14.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.904 12.033c-1.043 0-1.896-.828-1.896-1.839v-.46c0-1.011.853-1.838 1.896-1.838s1.897.827 1.897 1.838v.46c0 1.011-.854 1.839-1.897 1.839zm.949.919h-1.897c-1.327 0-2.37 1.012-2.37 2.299a11.63 11.63 0 0 0 3.318.492 11.63 11.63 0 0 0 3.32-.492c0-1.287-1.044-2.299-2.371-2.299z",
    fill: "#FFF"
  }))));
};
export default SvgPrivacyIcon;